

export class ImageResponseGet {
    id: number;

    published: boolean;
    name: string;
    url: any = '';
    
    alt: string;
    summary: string;
    tags: string;
    copyright: string;
    filename: string;
    

    createdAt: string;
    createdBy: string;
    modifiedAt: string;
    modifiedBy: string;
    privateUrl: string;
    publicUrl: string;
    signedUrl:string;
    
    status: string;
    
  }





export class ImageResponse{
    id: number;
    name: string;
    published: boolean;
    url: string;
    internalUrl: string;
    privateUrl: string;
    
}
export class ImageResponseData{
    id: number;
    name: string;
    published: boolean;
    url: string;
    createdAt: string;
    
}
export class ImageResponseTable{
    data: ImageResponseData[];
    limit: number;
    page: number;
    total: number;
    
}